import { environment } from "src/environments/environment";

export class SolUrls {
  // API Configs...
  private domainName = environment.url;
  private subDomainEnabled = false;
  private httpsEnabled = true;
  private apiSubDomainName = 'backend';
  private apiUrlExtension = '/api/v1';
  private apiStorageExtension = '/storage';
  private apiMultiUploadsExtension = 'uploadAttachments';
  private apiSingleUploadsExtension = 'uploadAttachment';
  // private imageUrl
  // API functions...
  private apiUrls: Map<string, string> = new Map<string, string>()
    .set('login', '/auth/login')
    .set('register', '/auth/register')
    .set('verify_email', '/auth/verify_email')
    .set('verify_token', '/auth/verify_token')
    .set('change_password', '/auth/change_password')
    .set('logout', 'logout')
    .set('forget-password', '/auth/forgot_password_email')
    .set('homePage', '/HomePage/getHomePage')
    .set('getParagraphPages', '/ParagraphPages/getParagraphPages')
    .set('checkUserType', 'userTypeChecker')
    .set('checkAuth', 'authenticationChecker')
    .set('fraudTypesWithEachSub', '/FraudTypes/getFraudTypesWithEachSub')
    .set('getFraudTypes', '/FraudTypes/getFraudTypes')
    .set('getMediaImages', '/Media/getMediaImages')
    .set('getMediaVideos', '/Media/getMediaVideos')
    .set('getImportantLinks', '/ImportantLinks/getImportantLinks')
    .set('getNews', '/News/getNews')
    .set(
      'getCommonQuestionCategoryWithEachSub',
      '/CommonQuestionCategories/getCommonQuestionCategoryWithEachSub'
    )
    .set('getAllExperiments', '/Experiments/getAllExperiments')
    .set('addNewExperiments', '/auth/Experiments/addNewExperiments')
    .set('addContactUs', '/ContactUs/addContactUs')
    .set('getEvents', '/Events/getEvents')
    .set('getVotes', '/VotesFraud/getVotes')
    .set('addVote', '/VotesFraud/addVote')
    .set('subscription', '/Subscribe/addSubscriptionMail')
    .set('getAllStories', '/TrueStories/getAllTrueStories')
    .set('resendVerifEmail', '/auth/resend_verification_email')
    .set('userProfile','/auth/user')
    .set('userProfileUpdate','/auth/user/update_profile')
    .set('latestFraudSubCategory', '/FraudTypes/getLatestFraudSubcategory')
    .set('changePassword','/auth/user/change_password')
    .set('changeEmail','/auth/change_email')
    .set('getExperiment', '/Experiments/getSingleExperiment')
    .set('getStory','/TrueStories/getSingleTrueStory')
    .set('getSearchValue', '/ElasticSearch/getElasticSearch ')
    .set('getFraudComments', '/auth/FraudComments/getFraudComments')
    .set('addFraudComment', '/auth/FraudComments/addFraudComment')
    .set('getExperimentComments', '/auth/ExperimentComments/getExperimentComments')
    .set('addExperimentComment', '/auth/ExperimentComments/addExperimentComment')
    .set('getMenu', '/auth/PageBuilder/getMenu')
    .set('ScamAdvisor', '/ScamAdvisor/getScamAdvisor')
    .set('getPage', '/auth/PageBuilder/getPage');

  public getApiUrl() {
    if (this.httpsEnabled) {
      if (this.subDomainEnabled) {
        return (
          'https://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiUrlExtension
        );
      } else {
        return 'https://' + this.domainName + this.apiUrlExtension;
      }
    } else {
      if (this.subDomainEnabled) {
        return (
          'http://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiUrlExtension
        );
      } else {
        return 'http://' + this.domainName + this.apiUrlExtension;
      }
    }
  }

  public getUploadsUrl(single = true) {
    if (this.httpsEnabled) {
      if (single) {
        return (
          'https://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiUrlExtension +
          this.apiSingleUploadsExtension
        );
      } else {
        return (
          'https://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiUrlExtension +
          this.apiMultiUploadsExtension
        );
      }
    } else {
      if (single) {
        return (
          'http://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiUrlExtension +
          this.apiSingleUploadsExtension
        );
      } else {
        return (
          'http://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiUrlExtension +
          this.apiMultiUploadsExtension
        );
      }
    }
  }

  public getStorageUrl() {
    if (this.httpsEnabled) {
      if (this.subDomainEnabled) {
        return (
          'https://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiStorageExtension
        );
      } else {
        return 'https://' + this.domainName + this.apiStorageExtension;
      }
    } else {
      if (this.subDomainEnabled) {
        return (
          'http://' +
          this.apiSubDomainName +
          '.' +
          this.domainName +
          this.apiStorageExtension
        );
      } else {
        return 'http://' + this.domainName + this.apiStorageExtension;
      }
    }
  }

  public getFunction(key: string) {
    return this.getApiUrl() + this.apiUrls.get(key);
  }
}
